// frontend/modules/internal-account/routes.tsx
import { RouteObject } from 'react-router-dom';
import { ErrorBoundary } from '@/shared/components/ErrorBoundary';
import InternalAccountManagementView from './views/InternalAccountManagementView';
import InternalAccountFormView from './views/InternalAccountFormView';
import TransaccManagementView from './views/TransaccManagementView';
import TransaccFormView from './views/TransaccFormView';

export const internalAccountRoutes: RouteObject[] = [
    {
        path: '/customers/internal',
        element: <InternalAccountManagementView />,
        errorElement: <ErrorBoundary />
    },
    {
        path: '/customers/internal/new',
        element: <InternalAccountFormView />,
        errorElement: <ErrorBoundary />
    },
    {
        path: '/customers/internal/edit/:branch/:glNo/:acNo',
        element: <InternalAccountFormView />,
        errorElement: <ErrorBoundary />
    },
    {
        path: '/customers/transacc',
        element: <TransaccManagementView />,
        errorElement: <ErrorBoundary />
    },
    {
        path: '/customers/transacc/new',
        element: <TransaccFormView />,
        errorElement: <ErrorBoundary />
    },
    {
        path: '/customers/transacc/edit/:glNo/:acNo',
        element: <TransaccFormView />,
        errorElement: <ErrorBoundary />
    }
];
